
import { fetchToken } from "../../../common/FetchCookie"
import { SUBSCRIPTION_DETAILS_EMPLOYER, SUBSCRIPTIONS_TOPUP_EMPLOYER } from "../../../common/URLs"
// import { SUBSCRIPTION_DETAILS_EMPLOYER, SUBSCRIPTIONS_TOPUP } from "../../common/URLs"

export const fetchSubscriptionEmployerTopUp = async () => {
    try {
        const token = await fetchToken()
        const response = await fetch(SUBSCRIPTIONS_TOPUP_EMPLOYER, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
        if (!response.ok) {
            const errorData = await response.json()
            throw new Error(errorData.response?.msg || `HTTP error! Status: ${response.status}`)
        }
        const data = await response.json()
        return data.response || []
    } catch (error) {
        console.error("API Error:", error)
        throw error
    }
}

export const addSubscriptionEmployerTopUp = async (newSubscription) => {
    try {
        const token = await fetchToken()
        const response = await fetch(SUBSCRIPTIONS_TOPUP_EMPLOYER, {
            method: "POST",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(newSubscription),
        })
        if (!response.ok) {
            const errorData = await response.json()
            throw new Error(errorData.response?.msg || `Error adding subscription: ${response.statusText}`)
        }
        const data = await response.json()
        return data.response || data
    } catch (error) {
        console.error("Add error:", error)
        throw error
    }
}

export const updateSubscriptionEmployerTopUp = async (id, updateSubscriptiondata) => {
    try {
        const token = await fetchToken()
        const response = await fetch(`${SUBSCRIPTIONS_TOPUP_EMPLOYER}/${id}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(updateSubscriptiondata),
        })
        if (!response.ok) {
            const errorData = await response.json()
            throw new Error(errorData.response?.msg || `Error updating: ${response.statusText}`)
        }
        const data = await response.json()
        return data.response || data
    } catch (error) {
        console.error("Update error:", error)
        throw error
    }
}

export const deleteSubscriptionEmployerTopUp = async (id) => {
    try {
        const token = await fetchToken()
        const response = await fetch(`${SUBSCRIPTIONS_TOPUP_EMPLOYER}/${id}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
        if (!response.ok) {
            const errorData = await response.json()
            throw new Error(errorData.response?.msg || `Error deleting: ${response.statusText}`)
        }
        return { success: true, id }
    } catch (error) {
        console.error("Delete error:", error)
        throw error
    }
}


